export default __webpack_public_path__ + "static/hero-splendeur-bg-fc970ca8c7530f446b53f35097f634e2.webp";